/**
 * SFrame257 — Close estate accounts (standard step page).
 */

import SettlementStepPage from '../settlement/SettlementStepPage';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';

const step = SETTLEMENT_PHASE_CONFIGS.close.steps.find((s) => s.id === 'cls-4')!;

export default function SFrame257() {
  return <SettlementStepPage step={step} phase="close" overviewRoute="/sframe-250" />;
}
